import { ModalWrapper } from '@/shared';
import React from 'react';
import { AddResidentForm } from '../AddResidentForm';

interface AddResidentModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AddResidentModal: React.FC<AddResidentModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-center w-full min-h-full">
        <AddResidentForm onClose={onClose} />
      </div>
    </ModalWrapper>
  );
};
